import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { AdsPromptItem } from '@brand24-original/llm-types';
import { AdsFilters, getAdsPromptStats } from '../../services/ads/AdsService';
import { GET_ADS_PROMPT_STATS } from '../../query/ads/keys';

export const useGetAdsPromptStats = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  filters: AdsFilters,
  enabled = true
) => {
  const queryEnabled = !!projectId && !!from && !!to && enabled;

  const { data, isLoading, isError, refetch } = useQuery<AdsPromptItem[]>({
    queryKey: [GET_ADS_PROMPT_STATS, projectId, from, to, filters.models, filters.promptIds, filters.advertisers],
    queryFn: () => getAdsPromptStats(projectId!, from!, to!, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    placeholderData: keepPreviousData,
  });

  return {
    promptStats: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
